import * as angular from 'angular';
import * as moment from 'moment';

import { TicketViewModel } from '../../models';

export function computeDueInDays(ticketViewModel: TicketViewModel, $translate: angular.translate.ITranslateService): string {
    let dueInDays: string;
    const now = moment();
    let dueDate: moment.Moment;
    if (ticketViewModel.model.dueDate && !ticketViewModel.model.revisedDueDate) {
        dueDate = moment(ticketViewModel.model.dueDate);
    }

    if (ticketViewModel.model.revisedDueDate) {
        dueDate = moment(ticketViewModel.model.revisedDueDate);
    }

    try {
        const difference = dueDate.diff(now, 'days');
        if (!difference) {
            dueInDays = 'Today';
        } else if (difference === 1) {
            dueInDays = 'Tomorrow';
        } else if (difference > 1) {
            dueInDays = `${difference.toString()} ${$translate.instant('days')}`;
        } else {
            dueInDays = 'Overdue';
        }
    }
    catch {
        dueInDays = '?';
    }
    return dueInDays;
}